import type { FC, ReactNode } from 'react';
import { useCallback, useTransition } from 'react';
import { ArrowBack, MenuOpenOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router';
import { useCabinetStore } from 'features/cabinet';
import { Box, Divider, IconButton, Typography } from '@mui/material';

interface CabinetTitlePageProps {
  title: string;
  titleBadge?: ReactNode;
  endAdornment?: ReactNode;
  goBack?: boolean | string;
}

const CabinetTitlePage: FC<CabinetTitlePageProps> =
  ({
     title,
     titleBadge,
     endAdornment,
     goBack,
   }) => {
    const { expandedMenu, setExpandedMenu } = useCabinetStore();
    const [isPending, startTransition] = useTransition();
    const navigate = useNavigate();

    const handleToggleMenu = useCallback(() => {
      startTransition(() => {
        setExpandedMenu(!expandedMenu);
      });
    }, [expandedMenu, setExpandedMenu]);

    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          mb: 2,
          justifyContent: endAdornment ? 'space-between' : 'start',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center',
          }}
        >
          {goBack && (
            <IconButton
              onClick={() => {
                navigate(typeof goBack === 'string' ? goBack : '-1');
              }}
            >
              <ArrowBack />
            </IconButton>
          )}
          <IconButton onClick={handleToggleMenu} disabled={isPending}>
            <MenuOpenOutlined />
          </IconButton>
          <Typography variant={'subtitle1'}>{title}</Typography>
          {titleBadge && (
            <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
              {titleBadge}
            </Box>
          )}
        </Box>
        {endAdornment && (
          <Box>
            <Divider orientation="vertical" flexItem />
            {endAdornment}
          </Box>
        )}
      </Box>
    );
  };

export default CabinetTitlePage;
